import Navigationbar from "../Navigationbar";
import React, {useState} from "react";
import Messanger from "./Messanger";
import NotificationManager from "./NotificationManager";
import ProvideSocket from "./SocketProvider";
import {Link, useLocation} from "react-router-dom";
import EvacuationList from "./EvacuationList";
import PushNotification from "./PushNotification";
import {Nav, Tab, Tabs} from "react-bootstrap";
import CalendarView from "../calendar/CalendarView";
import { useTranslation } from 'react-i18next';


export default function ControllRoom(){
    const {hash} = useLocation();
    const [key, setKey] = useState('calendar');
    const { t } = useTranslation();

    return (
        <>
            <Navigationbar/>
            <div className={"d-flex"}>
                <div className="messanger">
                    <NotificationManager />
                    <ProvideSocket hash={hash}>
                        <>
                            <Messanger />
                            <PushNotification />
                        </>
                    </ProvideSocket>
                </div>
                <div className={"rightTab"}>
                    <Tabs
                        id="controlled-tab-example"
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                        className="mb-3"
                    >
                        <Tab eventKey="calendar" title={t('control.tabCalendar')}>
                            <CalendarView />
                        </Tab>
                        <Tab eventKey="profile" title={t('control.tabEvacPlans')}>
                            <EvacuationList />
                        </Tab>
                    </Tabs>
                </div>
            </div>

        </>
    )
}